import React, { useContext, useEffect, useState } from "react"
import DatePicker from "../../../components/Datepicker"
import { SpaceProfileContext } from "../context"
import UserImage from "../BookTour/UserImage"
import * as s from "./Step1.module.less"

const Step1 = ({ space, apiData }) => {
  const {
    commonData: { contextMinDate, contextMaxDate, teamSize },
    actions: { setContextDate, setBookTourStep },
  } = useContext(SpaceProfileContext)

  const [date, setDate] = useState(contextMinDate)

  useEffect(() => {
    setDate(contextMinDate)
  }, [contextMinDate])

  const updateDatepicker = (newDate) => {
    setBookTourStep(2)
    setContextDate(newDate)
    setDate(newDate)
  }

  return (
    <div>
      <div className={s.user_data}>
        <h5>
          Schedule a<br />
          30-minute call
        </h5>
        <UserImage space={apiData} />
        <p>{apiData.contact_name}</p>
      </div>
      <DatePicker
        value={date}
        setValue={updateDatepicker}
        maxDate={contextMaxDate || null}
        minDate={contextMinDate || null}
        inline
      />
      <span className={s.tz}>Eastern Time - Toronto</span>
    </div>
  )
}

export default Step1
